/**
 * App-wide image references (Unsplash IDs from the brief).
 */

export const IMG = {
  // Auth carousel
  authFood: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1600&q=85&auto=format",
  authTrainer: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1600&q=85&auto=format",
  // Onboarding
  onbGym: "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=1600&q=85&auto=format",
  onbFood: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1600&q=85&auto=format",
  onbCommunity: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1600&q=85&auto=format",
  // Home tiles
  todayWorkout: "https://images.unsplash.com/photo-1574680178050-55c6a6a96e0a?w=1200&q=85&auto=format",
  scanFood: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&q=85&auto=format",
  trainerTile: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=85&auto=format",
  bodyScan: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=85&auto=format",
  community: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=800&q=85&auto=format",
  // Goal tiles
  goalLose: "https://images.unsplash.com/photo-1571019613576-2b22c76fd955?w=800&q=85&auto=format",
  goalGain: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=85&auto=format",
  goalEndurance: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=800&q=85&auto=format",
  goalMaintain: "https://images.unsplash.com/photo-1588286840104-8957b019727f?w=800&q=85&auto=format",
  // Coming soon
  yoga: "https://images.unsplash.com/photo-1588286840104-8957b019727f?w=1600&q=85&auto=format",
  zumba: "https://images.unsplash.com/photo-1571019613576-2b22c76fd955?w=1600&q=85&auto=format",
};
